import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {WebmateBrowserModule} from "@webmate-web-core/shared/components/browser/webmate-browser.module";
import {ArtifactComponent} from "./artifact.component";
import {ArtifactSummaryComponent} from "./summaries/artifact-summary.component";
import {GenericArtifactSummaryComponent} from './summaries/generic-artifact-summary.component';
import {FindingComponent} from './finding.component';
import {FindingSummaryComponent} from './summaries/finding-summary.component';
import {GenericFindingSummaryComponent} from './summaries/generic-finding-summary.component';
import {ScreenshotArtifactComponent} from './screenshot-artifact.component';
import {ScreenshotArtifactSummaryComponent} from './summaries/screenshot-artifact-summary.component';
import {MailContentArtifactComponent} from './mailcontent-artifact/mailcontent-artifact.component';
import {MailContentArtifactSummaryComponent} from './summaries/mailcontent-artifact-summary.component';
import {AdhocFindingSummaryComponent} from './summaries/adhoc-finding-summary.component';
import {AdhocFindingComponent} from './adhoc-finding.component';
import {FormsModule} from "@angular/forms";
import {SessionVideoArtifactSummaryComponent} from './summaries/sessionvideo-artifact-summary.component';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {SessionVideoArtifactComponent} from './sessionvideo-artifact.component';
import {ScreenshotModule} from "@webmate-web-core/shared/components/screenshot/screenshot.module";
import {
    MailDetailsComponent
} from "@webmate-web-core/shared/components/facts/mailcontent-artifact/mail-details.component";
import {MailContentFindingComponent} from "@webmate-web-core/shared/components/facts/mailcontent-finding.component";
import {TooltipModule} from 'primeng/tooltip';
import {FindingFindingComponent} from "@webmate-web-core/shared/components/facts/finding-finding.component";
import {EditorModule} from "primeng/editor";
import {PopoverModule} from "primeng/popover";
import {RefsSharedModule} from "@webmate-web-core/shared/components/refs/refs-shared.module";
import {SpecsSharedModule} from "@webmate-web-core/shared/components/specs/specs-shared.module";
import {VideosnippetArtifactComponent} from "@webmate-web-core/shared/components/facts/videosnippet-artifact.component";
import {WCAGReportArtifactComponent} from "@webmate-web-core/shared/components/facts/wcagreport-artifact.component";
import {AvatarModule} from "@webmate-web-core/shared/components/avatar/avatar.module";
import {ResourceViewsModule} from "@webmate-web-core/shared/components/resources/resource-views.module";
import {A11yReportArtifactComponent} from "@webmate-web-core/shared/components/facts/a11yreport-artifact.component";
import {AccordionModule} from "primeng/accordion";
import {ButtonModule} from "primeng/button";
import {CheckboxModule} from "primeng/checkbox";
import {Tab, TabList, TabPanel, TabPanels, Tabs} from 'primeng/tabs';
import {WmCalendarFormatPipe} from '@webmate-web-core/shared/utils/pipes/wm-calendar-format';
import {WmDateFormatPipe} from '@webmate-web-core/shared/utils/pipes/wm-date-format.pipe';
import {TextareaModule} from 'primeng/textarea';
import {FormsCommonsModule} from '@webmate-web-core/shared/components/forms-commons/forms-commons.module';
import {FindingSeverityIndicatorComponent} from '@webmate-web-core/shared/components/findings/finding-severity-indicator.component';
import {InputText} from "primeng/inputtext";
import {TagsModule} from '@webmate-web-core/shared/components/tags/tags.module';
import {MailOverviewComponent} from '../../../../workbench/shared/components/mail-overview/mail-overview.component';
import {FindingContentCellSummaryComponent} from '@webmate-web-core/shared/components/facts/summaries/finding-content-cell-summary.component';
import {FindingContentCellComponent} from '@webmate-web-core/shared/components/facts/finding-content-cell.component';
import {ProgressSpinner} from 'primeng/progressspinner';
import {A11yObservationListComponent} from '@webmate-web-core/shared/components/facts/a11y-observation-list.component';
import {ContentAnalysisArtifactComponent} from '@webmate-web-core/shared/components/facts/contentanalysis-artifact.component';
import {ProgressBarModule} from 'primeng/progressbar';
import {FindingShareComponent} from '@webmate-web-core/shared/components/findings/finding-share.component';
import {AddFindingButtonComponent} from '@webmate-web-core/shared/components/findings/add-finding-button.component';
import {WmDirectivesModule} from '@webmate-web-core/shared/directives/directives.module';
import {Menu} from "primeng/menu";
import {TieredMenuModule} from 'primeng/tieredmenu';
import {BlobBackedArtifactComponent} from '@webmate-web-core/shared/components/facts/blob-backed-artifact.component';

@NgModule({
    declarations: [
        ArtifactComponent,
        BlobBackedArtifactComponent,
        ArtifactSummaryComponent,
        A11yObservationListComponent,
        A11yReportArtifactComponent,
        ContentAnalysisArtifactComponent,
        GenericArtifactSummaryComponent,
        FindingComponent,
        FindingSummaryComponent,
        FindingFindingComponent,
        GenericFindingSummaryComponent,
        MailContentArtifactComponent,
        MailContentFindingComponent,
        MailContentArtifactSummaryComponent,
        MailDetailsComponent,
        ScreenshotArtifactComponent,
        ScreenshotArtifactSummaryComponent,
        AdhocFindingSummaryComponent,
        AdhocFindingComponent,
        SessionVideoArtifactComponent,
        SessionVideoArtifactSummaryComponent,
        VideosnippetArtifactComponent,
        WCAGReportArtifactComponent,
        FindingContentCellSummaryComponent,
        FindingContentCellComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        TextareaModule,
        WebmateBrowserModule,
        FontAwesomeModule,
        ScreenshotModule,
        TooltipModule,
        EditorModule,
        PopoverModule,
        ProgressBarModule,
        WmDirectivesModule,
        ResourceViewsModule,
        RefsSharedModule,
        SpecsSharedModule,
        AvatarModule,
        AccordionModule,
        ButtonModule,
        CheckboxModule,
        Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel,
        WmCalendarFormatPipe,
        WmDateFormatPipe,
        FormsCommonsModule,
        InputText,
        FindingSeverityIndicatorComponent,
        TagsModule,
        MailOverviewComponent,
        ProgressSpinner,
        FindingShareComponent,
        AddFindingButtonComponent,
        Menu,
        TieredMenuModule,
    ],
    exports: [
        ArtifactComponent,
        ArtifactSummaryComponent,
        FindingFindingComponent,
        FindingComponent,
        FindingSummaryComponent,
        AddFindingButtonComponent,
        SessionVideoArtifactComponent,
        VideosnippetArtifactComponent,
        WCAGReportArtifactComponent,
        A11yReportArtifactComponent,
        ContentAnalysisArtifactComponent,
        MailContentArtifactComponent,
        FindingContentCellComponent,
    ]
})
export class FactsModule { }
